import AssertionPresetSetupBase, {
  AssertionPresetContent,
  AssertionPresetSetupProps,
} from "./AssertionPresetSetupBase";

const structuralPresetContent: AssertionPresetContent = {
  assertionTitle: "What structure should the output follow?",
  assertionHint:
    "Each assertion is a structure requirement. Separate independent rules for clearer results.",
  assertionPlaceholder: "Example: The output includes the summary field.",
  defaultAssertions: [
    "The output follows the required format.",
    "The output includes every required field or section.",
    "The output does not include extra top-level fields or sections unless allowed.",
  ],
  resultLabel: "Structure assertions",
  missingText: "Add at least one structure assertion.",
  tableInputText: "Prompt variables and assertion checks.",
};

const StructuralPresetSetup = (props: AssertionPresetSetupProps) => (
  <AssertionPresetSetupBase presetType="STRUCTURAL" content={structuralPresetContent} {...props} />
);

export default StructuralPresetSetup;
